import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: inline-block;

  input {
    cursor: pointer;
  }

  .click-to-copy {
    &__content {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    &__icon {
      margin-left: 5px;
    }

    &__placeholder {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10;
    }
  }
`;

export default Container;
